import { GlobalState } from "little-state-machine";
import { initialRequestsFilter } from "./initialRequestsFilter";
import { initialUserApplicationsFilter } from "./initialUserApplicationsFilter";
import { initialUserFilter } from "./InitialUserFilter";
import { initialUserHistoryFilter } from "./InitialUserHistoryFilter";

const initialState = () : GlobalState => ({
  actionsFiltered: undefined,
  isUserFilterDrawerOpen: false,
  isUserHistoryFilterDrawerOpen: false,
  isUserApplicationsFilterOpen: false,
  requestsFilter: initialRequestsFilter(),
  username: undefined,
  userFilter: initialUserFilter(),
  userApplicationsFilter: initialUserApplicationsFilter(),
  userHistoryFilter: initialUserHistoryFilter(),
  assignedClaimsWhitespace: [],
  sitesFiltered: [],
  applicationTypesFiltered: [],
  groupsFilteredUserApplications: [],
  groupsFilteredUsers: []
});

export { initialState };
